import React from 'react';
import Contact from '../components/Contact';

export default function ContactPage() {
  return (
    <div className="pt-48 pb-20 bg-stone-50 min-h-screen">
      {/* Reuse the Contact component but remove its internal padding/bg if possible, 
          or just let it be a section within this page. 
          Since Contact has py-24 bg-gray-50, we'll let it stand as its own block. */}
      <Contact />
    </div>
  );
}
